<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <v-col class="md-hidden pager-row">
      <span class="back-button" @click="goBack">
        <i class="fas fa-chevron-left m-r-5"></i>
        Go Back
      </span>
      <radial-progress-bar
        :diameter="45"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :startColor="'#00A8C8'"
        :stopColor="'#00A8C8'"
        :innerStrokeColor="'#B0E5EF'"
        :strokeWidth="3"
        :innerStrokeWidth="3"
        class="right progress-bar"
      >
        <p>
          <span>{{ completedSteps }}</span> of {{ totalSteps }}
        </p>
      </radial-progress-bar>
    </v-col>
    <div class="form-body col-md-8 col-12">
      <v-container class="insured-container">
        <v-col cols="12" sm="12" md="12" class="header-div">
          <h3>Insured Values</h3>
        </v-col>

        <v-row class="form-item-section">
          <v-col cols="12" sm="12" md="6" class="input-wrapper xs-hidden">
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="3"
            class="input-wrapper currency-container"
          >
            <v-list-item-title class="currency-label">
              Currency <span class="red-star">*</span>
            </v-list-item-title>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="3"
            class="input-wrapper currency-text currency-container"
          >
            <v-select
              v-model="insuredValue.currency"
              outlined
              dense
              color="primary"
              :items="currencyList"
              label="Select"
              item-text="value"
              item-value="key"
              :single-line="true"
              :rules="[rules.required]"
            />
          </v-col>

          <v-row class="hr-row"></v-row>

          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper table-div xs-hidden"
          >
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="3"
            class="input-wrapper table-div xs-hidden"
          >
            <v-list-item-title class="regular">Purchase Date</v-list-item-title>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="2-5"
            class="input-wrapper table-div xs-hidden"
          >
            <v-list-item-title class="regular"
              >Purchase Price</v-list-item-title
            >
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="2-5"
            class="input-wrapper table-div xs-hidden"
          >
            <v-list-item-title class="regular">Insured Value</v-list-item-title>
          </v-col>

          <!-- Test Boxes Start  -->

          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper table-div heading-xs"
          >
            <v-list-item-title>
              Hull and equipment, including inboard engine (if any)
              <span class="red-star xs-hidden">*</span>
            </v-list-item-title>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Date <span class="red-star">*</span></v-list-item-title
            >
            <v-menu
              v-model="hullDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  append-icon=" "
                  v-on:click:append="
                    on;
                    hullDate = true;
                  "
                  outlined
                  dense
                  color="primary"
                  placeholder="DD/MM/YY"
                  :rules="[rules.required, rules.dateValidation]"
                  :value="insuredValue.purchase_date_hull | moment"
                  @keypress="isDateText($event)"
                  @blur="formatDate($event, 'purchase_date_hull')"
                  maxlength="8"
                  validate-on-blur
                  ref="hullDateTextBox"
                />
              </template>
              <v-date-picker
                v-model="insuredValue.purchase_date_hull"
                no-title
                locale="en-in"
                color="primary"
                @input="closeDatePicker('hullDate', 'hullDateTextBox')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Price <span class="red-star">*</span></v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.purchase_price_hull"
              color="primary"
              solo
              outlined
              flat
              dense
              @focus="removeComma('purchase_price_hull')"
              @blur="formatPrice('purchase_price_hull')"
              @keypress="isNumber($event)"
              :rules="[rules.required, rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Insured Value <span class="red-star">*</span></v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.insured_value_hull"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @blur="
                calculateTotalSum();
                formatPrice('insured_value_hull');
              "
              @focus="removeComma('insured_value_hull')"
              :rules="[rules.required, rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right semi-bold"
            />
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper table-div heading-xs"
          >
            <v-list-item-title>
              Dinghy/tender/toys (if any) to the yacht
            </v-list-item-title>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Date</v-list-item-title
            >
            <v-menu
              v-model="dinghyDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on:click:append="
                    on;
                    dinghyDate = true;
                  "
                  outlined
                  dense
                  append-icon=" "
                  color="primary"
                  placeholder="DD/MM/YY"
                  :rules="[rules.dateValidation]"
                  :value="insuredValue.purchase_date_dinghy | moment"
                  @blur="formatDate($event, 'purchase_date_dinghy')"
                  maxlength="8"
                  validate-on-blur
                  ref="dinghyDateTextBox"
                />
              </template>
              <v-date-picker
                v-model="insuredValue.purchase_date_dinghy"
                no-title
                locale="en-in"
                color="primary"
                @input="closeDatePicker('dinghyDate', 'dinghyDateTextBox')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Price</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.purchase_price_dinghy"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @focus="removeComma('purchase_price_dinghy')"
              @blur="formatPrice('purchase_price_dinghy')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              class="input-right"
              maxLength="9"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Insured Value</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.insured_value_dinghy"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @blur="
                calculateTotalSum();
                formatPrice('insured_value_dinghy');
              "
              @focus="removeComma('insured_value_dinghy')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              class="input-right semi-bold"
              maxLength="9"
            />
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper table-div heading-xs"
          >
            <v-list-item-title>
              Personal effects (if any)
            </v-list-item-title>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Date</v-list-item-title
            >
            <v-text-field
              color="primary"
              solo
              outlined
              flat
              dense
              :disabled="true"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Price</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.purchase_price_personal_effect"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @focus="removeComma('purchase_price_personal_effect')"
              @blur="formatPrice('purchase_price_personal_effect')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Insured Value</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.insured_value_personal_effect"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @blur="
                calculateTotalSum();
                formatPrice('insured_value_personal_effect');
              "
              @focus="removeComma('insured_value_personal_effect')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right semi-bold"
            />
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="4"
            class="input-wrapper table-div heading-xs"
          >
            <v-list-item-title>
              Special equipment (if any)
            </v-list-item-title>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Date</v-list-item-title
            >
            <v-menu
              v-model="specialDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on:click:append="
                    on;
                    specialDate = true;
                  "
                  outlined
                  dense
                  append-icon=" "
                  color="primary"
                  placeholder="DD/MM/YY"
                  :rules="[rules.dateValidation]"
                  :value="insuredValue.purchase_date_special_equipment | moment"
                  @blur="formatDate($event, 'purchase_date_special_equipment')"
                  maxlength="8"
                  validate-on-blur
                  ref="specialDateTextBox"
                />
              </template>
              <v-date-picker
                v-model="insuredValue.purchase_date_special_equipment"
                no-title
                locale="en-in"
                color="primary"
                @input="closeDatePicker('specialDate', 'specialDateTextBox')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Purchase Price</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.purchase_price_special_equipment"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @focus="removeComma('purchase_price_special_equipment')"
              @blur="formatPrice('purchase_price_special_equipment')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2-5" class="input-wrapper table-div">
            <v-list-item-title class="md-hidden"
              >Insured Value</v-list-item-title
            >
            <v-text-field
              v-model="insuredValue.insured_value_special_equipment"
              color="primary"
              solo
              outlined
              flat
              dense
              @keypress="isNumber($event)"
              @blur="
                calculateTotalSum();
                formatPrice('insured_value_special_equipment');
              "
              @focus="removeComma('insured_value_special_equipment')"
              :rules="[rules.numberRule, rules.negativeValidation]"
              :validate-on-blur="true"
              maxLength="9"
              class="input-right semi-bold"
            />
          </v-col>

          <v-row class="hr-row md-hidden m-t-20"></v-row>

          <v-col
            cols="12"
            sm="6"
            md="4"
            class="input-wrapper table-div total-container"
          >
            <v-list-item-title class="semi-bold">
              Total sum to be insured
            </v-list-item-title>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="8"
            class="input-wrapper table-div total-container"
          >
            <div class="total-text-box">
              {{ totalSum }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="!$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="goBack"
      >
        <span class="back-icon"></span>
        Previous Step
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="validateAndGoNext"
      >
        Continue
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="cancelChange"
      >
        <span class="back-icon"></span>
        Cancel Changes
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="applyChange"
      >
        Apply Changes
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapGetters, mapMutations } from "vuex";
import RadialProgressBar from "vue-radial-progress";
import PremiumApi from "@/plugins/axios";

export default {
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      valid: false,
      completedSteps: 4,
      totalSteps: 7,
      insuredValue: this.getInsuredValue(),
      totalSum: 0,
      nowDate: new Date().toISOString().slice(0, 10),
      rules: {
        required: (value) => !!value || "This field is mandatory",
        fileSize: (value) => this.photos > 0 || "This field is mandatory",
        dateValidation: (value) => {
          if (value == null || value == undefined || value == "") {
            return true;
          }
          if (
            moment(value, "DDMMYY", true).isValid() ||
            moment(value, "DD/MM/YY", true).isValid()
          ) {
            return true;
          }
          return "Invalid Date Format";
        },
        numberRule: (value) => {
          const pattern = /^\d+$/;
          if (value == null || value == undefined || value == "") {
            return true;
          }
          return (
            pattern.test(
              String(value)
                .replace(/\,/g, "")
                .replace(/\-/g, "")
            ) || "This field must have numeric value"
          );
        },
        negativeValidation: (value) => {
          if (value == null || value == undefined || value == "") {
            return true;
          }
          return parseFloat(value) >= 0 || "Value should not be negative";
        },
        emailValidation: (value) => {
          var pattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
          if (value == null || value === undefined || value === "") {
            return true;
          }
          return pattern.test(value) || "E-mail must be valid";
        },
      },
      hullDate: false,
      dinghyDate: false,
      specialDate: false,
    };
  },
  filters: {
    moment: function(date) {
      var result = moment(date).format("DD/MM/YY");
      if (result === "Invalid date") {
        return "";
      } else {
        return moment(date).format("DD/MM/YY");
      }
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateAndGoNext: function() {
      if (this.$refs.form.validate()) {
        this.insuredValue.total = this.totalSum;
        this.$store.commit("saveInsuredValue", this.insuredValue);
        this.$store.state.formPageNumber = 5;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    goBack: function() {
      this.$store.state.formPageNumber = 3;
    },
    cancelChange: function() {
      this.$store.state.isEditMode = false;
      this.$store.state.formPageNumber = 7;
    },
    applyChange: function() {
      if (this.$refs.form.validate()) {
        this.insuredValue.total = this.totalSum;
        const oldFormValue = this.getInsuredValue();
        let pageNumber = 7;
        let editModeFlag = false;
        if (this.insuredValue.currency !== oldFormValue.currency) {
          const policyDetails = this.getPolicyDetails();
          policyDetails.limit_third_party_liability = null;
          policyDetails.limit_liability = null;
          pageNumber = 5;
          editModeFlag = true;
          this.$store.commit("savePolicyDetails", policyDetails);
        }
        this.$store.commit("saveInsuredValue", this.insuredValue);
        this.$store.state.isEditMode = editModeFlag;
        this.$store.state.formPageNumber = pageNumber;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    moment: function(e) {
      return moment();
    },
    getInsuredValue: function() {
      return _.cloneDeep(this.$store.getters.getInsuredValue);
    },
    getPolicyDetails: function() {
      return _.cloneDeep(this.$store.getters.getPolicyDetails);
    },
    calculateTotalSum: function() {
      const value1 = this.formatNumber(this.insuredValue.insured_value_hull);
      const value2 = this.formatNumber(this.insuredValue.insured_value_dinghy);
      const value3 = this.formatNumber(
        this.insuredValue.insured_value_special_equipment
      );
      const value4 = this.formatNumber(
        this.insuredValue.insured_value_personal_effect
      );
      this.totalSum = (value1 + value2 + value3 + value4).toLocaleString();
    },
    formatNumber(number) {
      return !number ? 0 : parseFloat(number.replace(/,/g, ""));
    },
    removeComma(key) {
      this.insuredValue[key] = !this.insuredValue[key]
        ? null
        : this.insuredValue[key].replace(/,/g, "");
    },
    formatPrice(key) {
      this.insuredValue[key] = !this.insuredValue[key]
        ? null
        : parseFloat(this.insuredValue[key]).toLocaleString();
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/InsuredValue";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
    formatDate: function(e, key) {
      let date = e.target.value;
      if (
        moment(date, "DDMMYY", true).isValid() ||
        moment(date, "DD/MM/YY", true).isValid()
      ) {
        e.target.value = moment(date, "DDMMYY").format("DD/MM/YY");
        this.insuredValue[key] = moment(date, "DDMMYY").format("YYYY-MM-DD");
      }
    },
    isDateText: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 47 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    closeDatePicker: function(flag, textBoxRef) {
      let _this = this;
      _this[flag] = false;
      setTimeout(()=> {
        _this.$refs[textBoxRef].validate();
      }, 500);
    }
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.calculateTotalSum();
    this.trackPage();
  },
  computed: {
    ...mapGetters(["currencyList"]),
  },
};
</script>
